/**
 * Exact-or-subdomain hostname match. `hostMatchesDomain("evilmatterport.com",
 * "matterport.com")` is false, unlike `hostname.endsWith("matterport.com")`.
 * Pure string logic so it is safe in both client and server modules.
 */
export function hostMatchesDomain(hostname: string, domain: string): boolean {
  const host = hostname.toLowerCase().replace(/\.$/, "");
  const target = domain.toLowerCase();
  return host === target || host.endsWith(`.${target}`);
}

/** Parse the hostname out of a URL-ish string, or `null` when it does not parse. */
export function hostnameOf(url: string): string | null {
  try {
    return new URL(url).hostname.toLowerCase();
  } catch {
    return null;
  }
}
